import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import { Label } from "flowbite-react";
import config from "../../config/config";
import constants from '../../constant.js';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PlusIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

dayjs.extend(customParseFormat);
dayjs.extend(utc);

const ShuttleJourney = () => {
    const date = dayjs().utc();
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [shuttleRoutesData, setShuttleRoutesData] = useState([]);
    const [route, setRoute] = useState('');
    const [cancellation, setCancellation] = useState('');
    const [passCancellation, setPassCancellation] = useState('');
    const [cancellationData, setCancellationData] = useState([]);
    const [shuttleVehicleData, setShuttleVehicleData] = useState([]);
    const [vehicle, setVehicle] = useState('');
    const [startTime, setStartTime] = useState(date);
    const [weekDaysData, setWeekDaysData] = useState('');
    const [drivers, setDrivers] = useState('');
    const [driverData, setDriversData] = useState([]);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [tripData, setTripData] = useState([]);
    const [promoTypeData, setPromoTypeData] = useState([]);
    const [promoType, setPromoType] = useState('');
    const [termsLink, setTermsLink] = useState('');
    const [tncPointer, setTncPointer] = useState(['']);
    const [passTermsLink, setPassTermsLink] = useState('');
    const [passTncPointer, setPassTncPointer] = useState(['']);
    const [pointerError, setPointerError] = useState('');
    const [passPointerError, setPassPointerError] = useState('');
    const [dayFilter, setDayFilter] = useState(() => {
        const savedFilter = localStorage.getItem('dayFilter');
        return savedFilter !== null ? Number(savedFilter) : 1;
    });
    const [isEditingLink, setIsEditingLink] = useState(false);
    const [routeName, setRouteName] = useState('');
    const [tripId, setTripId] = useState('');
    const [orderBy, setOrderBy] = useState('trip_id');
    const [order, setOrder] = useState('desc');
    const driverDataShown = localStorage.getItem('hidedriverinfo');

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setStartTime(date);
        setTripId("");
        // setWeekDaysData('');
        setRoute('');
        setVehicle('');
        setDrivers('');
        // setWeekDaysData(row.day);
        setCancellation('');
        setPassCancellation('');
        setRouteName('');
        setPromoType('');
        setTncPointer(['']);
        setTermsLink('');
        setPassTermsLink('');
        setPassTncPointer(['']);
    }
    const handleClose = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
    }

    const ShutteWeekdaysConst = constants.ShutteWeekdaysConst;
    const weekdaysArray = [
        { name: 'Sun', value: ShutteWeekdaysConst.SUN },
        { name: 'Mon', value: ShutteWeekdaysConst.MON },
        { name: 'Tue', value: ShutteWeekdaysConst.TUE },
        { name: 'Wed', value: ShutteWeekdaysConst.WED },
        { name: 'Thu', value: ShutteWeekdaysConst.THUR },
        { name: 'Fri', value: ShutteWeekdaysConst.FRI },
        { name: 'Sat', value: ShutteWeekdaysConst.SAT },
    ];

    const handleCheckboxChange = (event) => {
        const value = String(event.target.value);
        const currentDays = weekDaysData.split(',').filter(Boolean); // Convert string to array

        if (event.target.checked) {
            // Add value and convert back to string
            setWeekDaysData([...currentDays, value].join(','));
        } else {
            // Remove value and convert back to string
            setWeekDaysData(currentDays.filter((day) => day !== value).join(','));
        }
    };

    const fetchShuttleRoutes = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_routes';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setShuttleRoutesData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchShuttleCancellation = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_cancellation_policy';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setCancellationData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchPromoType = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_city_promotions';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const data = response.data.filter((item) => item.is_active == 1);
                setPromoTypeData(data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchShuttleVehicle = async() => {
        try {
            const url = serverUrl + '/vehicle/fetch_vehicle_make';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setShuttleVehicleData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const handleAddTncPointer = () => {
        if (!tncPointer[tncPointer.length - 1]?.trim()) {
            setPointerError('Please insert pointer here first');
            return;
        }
        setPointerError('');
        setTncPointer([...tncPointer, '']);
    };
    const handleTncPointerChange = (index, value) => {
        setPointerError(''); // Clear error when user types
        const newPointers = [...tncPointer];
        newPointers[index] = value;
        setTncPointer(newPointers);
    };

    const handleRemoveTncPointer = (index) => {
        const newPointers = [...tncPointer];
        newPointers.splice(index, 1);
        setTncPointer(newPointers);
    };

    const handleAddPassTncPointer = () => {
        if (!passTncPointer[passTncPointer.length - 1]?.trim()) {
            setPassPointerError('Please insert pointer here first');
            return;
        }
        setPassPointerError('');
        setPassTncPointer([...passTncPointer, '']);
    };
    const handlePassTncPointerChange = (index, value) => {
        setPassPointerError(''); // Clear error when user types
        const newPointers = [...passTncPointer];
        newPointers[index] = value;
        setPassTncPointer(newPointers);
    };

    const handleRemovePassTncPointer = (index) => {
        const newPointers = [...passTncPointer];
        newPointers.splice(index, 1);
        setPassTncPointer(newPointers);
    };

    const fetchShuttleDrivers = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_shuttle_drivers';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setDriversData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchTripData = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_trips';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp,
                day: dayFilter
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // setTripData(response.data);
                const sortedData = [...response.data].sort((a, b) => {
                    return b.trip_id - a.trip_id;
                });
                
                setTripData(sortedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=>{
        localStorage.setItem('dayFilter', dayFilter);
        fetchShuttleRoutes();
        fetchShuttleCancellation();
        fetchShuttleVehicle();
        fetchTripData();
        fetchShuttleDrivers();
        fetchPromoType();
    },[dayFilter, cityFilter]);

    const handleSubmit = async() => {
        const formattedStartTime = startTime ? startTime.format("HH:mm:ss") : null;

        if(!route || !drivers || !vehicle || !weekDaysData) {
            setMessage('Please fill all the fields');
            showSnackbar(true);
            return;
        }
        const payload = {
            token: token,
            route_id: route,
            driver_id: drivers,
            city_id: cityFilter,
            vehicle_id: vehicle,
            time: formattedStartTime,
            days: weekDaysData,
            t_n_c: {
                t_n_c: tncPointer.filter(pointer => pointer.trim() !== ''), 
                t_n_c_link: termsLink,
                pass_t_n_c: passTncPointer.filter(pointer => pointer.trim() !== ''),
                pass_t_n_c_link: passTermsLink
            }
        };

        if(cancellation){
            payload.cancellation_policy_id = cancellation
        }
        if(passCancellation){
            payload.pass_cancellation_policy_id = passCancellation
        }
        if(promoType){
            payload.promo_id = promoType
        }

        // if(tncPointer && tncPointer.length > 0 && tncPointer[0] !== ''){
        //     payload.t_n_c = {
        //         t_n_c: tncPointer.filter(pointer => pointer.trim() !== ''), 
        //         t_n_c_link: termsLink
        //     };
        // }

        // if(passTncPointer && passTncPointer.length > 0 && passTncPointer[0] !== ''){
        //     if(!payload.t_n_c) {
        //         payload.t_n_c = {};
        //     }
        //     payload.t_n_c.pass_t_n_c = passTncPointer.filter(pointer => pointer.trim() !== '');
        //     payload.t_n_c.pass_t_n_c_link = passTermsLink;
        // }
        try {
            const url = operationsUrl + '/shuttle/add_trips';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddModal(false);
                setOpenEditModal(false);
                // fetchFareData();
                fetchTripData();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }
    

    const handleEditSubmit = async() => {
        const payload = {
            token: token,
            trip_id: tripId,
            driver_id: drivers,
            vehicle_id: vehicle,
            t_n_c: {
                t_n_c: tncPointer.filter(pointer => pointer.trim() !== ''), 
                t_n_c_link: termsLink,
                pass_t_n_c: passTncPointer.filter(pointer => pointer.trim() !== ''),
                pass_t_n_c_link: passTermsLink
            }
        };
        if(cancellation){
            payload.cancellation_policy_id = cancellation
        }
        if(passCancellation){
            payload.pass_cancellation_policy_id = passCancellation
        }

        if(promoType){
            payload.promo_id = promoType
        }

        // if(tncPointer && tncPointer.length > 0 && tncPointer[0] !== ''){
        //     payload.t_n_c = {
        //         t_n_c: tncPointer.filter(pointer => pointer.trim() !== ''), 
        //         t_n_c_link: termsLink
        //     };
        // }
        // if(passTncPointer && passTncPointer.length > 0 && passTncPointer[0] !== ''){
        //     if(!payload.t_n_c) {
        //         payload.t_n_c = {};
        //     }
        //     payload.t_n_c.pass_t_n_c = passTncPointer.filter(pointer => pointer.trim() !== '');
        //     payload.t_n_c.pass_t_n_c_link = passTermsLink;
        // }
        try {
            const url = operationsUrl + '/shuttle/edit_trip';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddModal(false);
                setOpenEditModal(false);
                fetchTripData();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const handleOpenEdit = (row) => {
        setOpenEditModal(true);
        setRoute(row.route_id);
        setVehicle(row.vehicle_id);
        setDrivers(row.driver_id);
        setStartTime(row.time);
        setTripId(row.trip_id);
        setCancellation(row.cancellation_policy_id);
        setPassCancellation(row.pass_cancellation_policy_id);
        setRouteName(row.route_name);
        setPromoType(row.promo_id);
        
        // Handle t_n_c data safely
        if (row.t_n_c) {
            // Handle regular T&C
            if (Array.isArray(row.t_n_c.t_n_c)) {
                setTncPointer([...row.t_n_c.t_n_c]);
                setTermsLink(row.t_n_c.t_n_c_link || '');
            } else {
                setTncPointer(['']);
                setTermsLink('');
            }
            
            // Handle passenger T&C
            if (Array.isArray(row.t_n_c.pass_t_n_c)) {
                setPassTncPointer([...row.t_n_c.pass_t_n_c]);
                setPassTermsLink(row.t_n_c.pass_t_n_c_link || '');
            } else {
                setPassTncPointer(['']);
                setPassTermsLink('');
            }
        } else {
            // Initialize with empty values if no t_n_c data exists
            setTncPointer(['']);
            setTermsLink('');
            setPassTncPointer(['']);
            setPassTermsLink('');
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleDeleteTrip = async(row) => {
        const payload = {
            token: token,
            trip_id: row.trip_id,
            day: dayFilter
            // is_active: 0
        };

        try {
            const url = operationsUrl + '/shuttle/delete_shuttle_trip';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchTripData();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const handleViewBookingDetails = (row) => {
        localStorage.setItem('dayFilter', dayFilter);
        navigate('/shuttle-trip-booking-details', { state: { rowData: row, dayFilter: dayFilter } })
    }
    useEffect(() => {
        const savedFilter = localStorage.getItem('dayFilter');
        if (savedFilter) {
            setDayFilter(savedFilter);
        }
    }, []);

    const handleFilterChange = (e) => {
        const value = e.target.value;
        setDayFilter(value);
        localStorage.setItem('dayFilter', value);
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const isValidUrl = (string) => {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    };

    const handleEditClick = () => {
        setIsEditingLink(true);
    };

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...tripData].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setTripData(sortedRows);
    };

    // useEffect(() => {
    //     if (tripData && tripData.length) {
    //       const sorted = [...tripData].sort((a, b) => {
    //         if (a['trip_id'] < b['trip_id']) return order === 'asc' ? -1 : 1;
    //         if (a['trip_id'] > b['trip_id']) return order === 'asc' ? 1 : -1;
    //         return 0;
    //       });
    //       setTripData(sorted);
    //     }
    // }, [tripData]);

    const exportCSV = () => {
        // Define which columns to include in the CSV
        const headers = [
            'Trip ID',
            'Route Name',
            'Driver Name',
            'Phone Number',
            'Vehicle Number',
            'Trip Time',
            'Cancellation Policy ID',
            'Pass Cancellation Policy ID',
            'Promotion'
        ];

        // Map the data rows to match the headers
        const csvData = tripData.map(row => {
            
            return [
                row.trip_id,
                row.route_name,
                row.driver_name || '--',
                driverDataShown == 0 ? row.phone_number || '--' : (() => {
                    if (!row.phone_number) return '****';
                    const phone = row.phone_number;
                    // Remove any non-digit characters for processing
                    const cleanPhone = phone.replace(/\D/g, '');
                    if (cleanPhone.length <= 4) return '****';
                    const firstTwo = cleanPhone.substring(0, 2);
                    const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                    const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                    return "+" + firstTwo + maskedMiddle + lastTwo;
                })() || '--',
                row.vehicle_number || '--',
                row.time,
                row.cancellation_policy_id || '--',
                row.pass_cancellation_policy_id || '--',
                row.promo_title || '--'
            ];
        });

        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        csvData.forEach(rowArray => {
            // Properly escape fields that might contain commas
            const formattedRow = rowArray.map(field => {
                // Convert to string and check if it needs quotes
                const stringField = String(field || '');
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    // Escape quotes and wrap in quotes
                    return `"${stringField.replace(/"/g, '""')}"`;  
                }
                return stringField;
            });
            csvContent += formattedRow.join(',') + '\n';
        });

        // Create a blob and download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.setAttribute('href', url);
        link.setAttribute('download', `trips_data.csv`);
        link.style.visibility = 'hidden';
        
        // Append to document, trigger download, and clean up
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Trip</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'48px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Select value={dayFilter} 
                    onChange={handleFilterChange}
                    style={{width: '190px',height:'48px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select Day</MenuItem>
                        {weekdaysArray.map((week) => (
                            <MenuItem key={week.name} value={week.value}>
                                {week.name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'48px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Trip
                    </Button>
                </Grid2>

                <Grid2 item sx={{marginLeft:'1%', marginLeft:'auto'}}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={exportCSV}
                        sx={{
                            height: '48px',
                            width: '180px',
                            textTransform: 'none',
                            borderRadius: '8px',
                            backgroundColor: '#36C68F',
                            '&:hover': {
                                backgroundColor: '#36C68F',
                            },
                        }}
                    >
                        Export CSV
                    </Button>
                </Grid2>
            </Grid2>

            {/* add - edit modal */}
            {(openAddModal || openEditModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '24px', marginTop: '8px', fontWeight: 'bold' }}>
                                    {openEditModal ? 'Edit Trip' : 'Add Trip'}
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Label>Select Route<span style={{ color: 'red' }}>*</span></Label>
                                        {openAddModal && (
                                            <Select sx={{marginTop:'2%'}}
                                                value={route} 
                                                fullWidth
                                                onChange={(e) => setRoute( e.target.value)}
                                                style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                
                                                    {shuttleRoutesData.map((routeData) => (
                                                        <MenuItem key={routeData.route_id} value={routeData.route_id}>
                                                            {routeData.route_name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        )}

                                        {openEditModal && (
                                            <Typography sx={{fontWeight:'600', fontSize:'18px'}}>{routeName}</Typography>
                                        )}
                                            
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Start Time<span style={{ color: 'red' }}>*</span></Label>
                                        <br/>
                                        {openAddModal && (
                                            <LocalizationProvider dateAdapter={AdapterDayjs} sx={{marginTop:'2%'}}>
                                                <TimePicker 
                                                    sx={{
                                                        marginTop:'2%',
                                                        width: '100%',
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '48px',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#FFFFFF',
                                                            border: 'none',
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: '16px',
                                                            padding: '0px 14px',
                                                        }
                                                    }}
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            placeholder: 'Select date and time'
                                                        }
                                                    }}
                                                    // label="Start Time"
                                                    value={startTime} fullWidth
                                                    onChange={(newValue) => setStartTime(newValue)}
                                                    ampm={false} // Disable AM/PM
                                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                                />
                                            </LocalizationProvider>
                                        )}

                                        {openEditModal && (
                                            <Typography sx={{fontWeight:'600', fontSize:'18px'}}>{startTime}</Typography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Select Vehicle<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={vehicle} 
                                            fullWidth
                                            onChange={(e) => setVehicle( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            
                                                {shuttleVehicleData.map((vehicleData) => (
                                                    <MenuItem key={vehicleData.id} value={vehicleData.id}>
                                                        {vehicleData.vehicle_number}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Drivers<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={drivers} 
                                            fullWidth
                                            onChange={(e) => setDrivers(e.target.value)} 
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            
                                                {driverData.map((driver) => (
                                                    <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                            <Typography>{driver.driver_name}</Typography>
                                                            <Typography sx={{fontSize:'12px', color: 'text.secondary'}}>{driverDataShown == 0 ? driver.phone_number : (() => {
                                                            if (!driver.phone_number) return '****';
                                                            const phone = driver.phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()}</Typography>
                                                        </Box>
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </Grid>

                                    {openAddModal && (
                                        <Grid2 item sx={{marginTop:'4%', marginLeft:'2%'}}>
                                            <Label>Week days<span style={{ color: 'red' }}>*</span></Label>
                                            
                                            
                                            <FormGroup>
                                                <Grid2 item>
                                                    <FormControlLabel control={<Checkbox value={1} checked={weekDaysData.includes(1)} onChange={handleCheckboxChange} />} label="Monday" />
                                                    <FormControlLabel control={<Checkbox value={2} checked={weekDaysData.includes(2)} onChange={handleCheckboxChange} />} label="Tuesday" value={2} />
                                                    <FormControlLabel control={<Checkbox value={3} checked={weekDaysData.includes(3)} onChange={handleCheckboxChange}/>} label="Wednesday" value={3} />
                                                    <FormControlLabel control={<Checkbox value={4} checked={weekDaysData.includes(4)} onChange={handleCheckboxChange} />} label="Thursday" value={4} />
                                                    <FormControlLabel control={<Checkbox value={5} checked={weekDaysData.includes(5)} onChange={handleCheckboxChange}/>} label="Friday" value={5} />
                                                    <FormControlLabel control={<Checkbox value={6} checked={weekDaysData.includes(6)} onChange={handleCheckboxChange} />} label="Saturday" value={6} />
                                                    <FormControlLabel control={<Checkbox value={0} checked={weekDaysData.includes(0)} onChange={handleCheckboxChange} />} label="Sunday" value={0} />
                                                </Grid2>
                                                
                                            </FormGroup>
                                        </Grid2>
                                    )}

                                    <Grid item xs={12} sm={12}>
                                        <Label>Cancellation Policy</Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={cancellation} 
                                            fullWidth
                                            onChange={(e) => setCancellation( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            
                                                {cancellationData.filter((item)=> item.is_shuttle_pass==0).map((cancelData) => (
                                                    <MenuItem key={cancelData.policy_id} value={cancelData.policy_id}>
                                                        {cancelData.name}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Pass Cancellation Policy</Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={passCancellation} 
                                            fullWidth
                                            onChange={(e) => setPassCancellation( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            
                                                {cancellationData.filter((item)=> item.is_shuttle_pass==1).map((cancelData) => (
                                                    <MenuItem key={cancelData.policy_id} value={cancelData.policy_id}>
                                                        {cancelData.name}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Promotion</Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={promoType} 
                                            fullWidth
                                            onChange={(e) => setPromoType( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            
                                                {promoTypeData.map((promoType) => (
                                                    <MenuItem key={promoType.id} value={promoType.id}>
                                                        {promoType.title}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Terms & Conditions Link</Label>
                                        <TextField
                                            sx={{marginTop:'2%'}}
                                            value={termsLink}
                                            fullWidth
                                            onChange={(e) => setTermsLink(e.target.value)}
                                            onBlur={() => {
                                                if (isValidUrl(termsLink)) {
                                                    setIsEditingLink(false);
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter' && isValidUrl(termsLink)) {
                                                    setIsEditingLink(false);
                                                }
                                            }}
                                            error={termsLink && !isValidUrl(termsLink)}
                                            helperText={termsLink && !isValidUrl(termsLink) ? 'Please enter a valid URL' : ''}
                                            InputProps={{
                                                style: { 
                                                    height: '50px', 
                                                    borderRadius: '8px', 
                                                    backgroundColor: '#FFFFFF',
                                                    color: (isValidUrl(termsLink) && !isEditingLink) ? '#1976d2' : 'inherit',
                                                    textDecoration: 'none',
                                                    cursor: (isValidUrl(termsLink) && !isEditingLink) ? 'pointer' : 'text',
                                                    paddingRight: '40px',
                                                },
                                                readOnly: !isEditingLink && isValidUrl(termsLink),
                                                onClick: (isValidUrl(termsLink) && !isEditingLink) ? () => {
                                                    window.open(
                                                        termsLink.startsWith('http') ? termsLink : `https://${termsLink}`,
                                                        '_blank',
                                                        'noopener,noreferrer'
                                                    );
                                                } : undefined,
                                                endAdornment: (isValidUrl(termsLink) && !isEditingLink) && (
                                                    <IconButton 
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleEditClick();
                                                        }}
                                                        size="small"
                                                        sx={{
                                                            position: 'absolute',
                                                            right: '8px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                                            }
                                                        }}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} style={{marginTop:'1%'}}>
                                        <Label>Terms & Conditions Pointers</Label>
                                        
                                        <div>
                                            {/* <Grid container spacing={2}>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Pointers</Typography>
                                                </Grid>
                                            </Grid> */}

                                            {tncPointer.length === 0 ? (
                                                // Show at least one empty field if array is empty
                                                <Grid container spacing={0} key={0} style={{ marginTop: '10px' }}>
                                                    <Grid item xs={10} sm={10} style={{ paddingRight: 0 }}>
                                                        <div style={{display:'flex',}}>
                                                            <Typography variant="subtitle2" style={{ color: '#4A4A4A',marginRight: '5px',marginTop:'1%' }}>1)</Typography>
                                                            <TextField 
                                                                placeholder="Please Enter Pointer 1" 
                                                                type="text" 
                                                                variant="outlined" 
                                                                fullWidth
                                                                value=""
                                                                onChange={(e) => handleTncPointerChange(0, e.target.value)}
                                                                error={!!pointerError}
                                                                helperText={pointerError}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {height: '35px',backgroundColor: '#FFFFFF',borderRadius: '8px 8px 8px 8px',borderRight: 'none'},
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2}>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={handleAddTncPointer}
                                                            startIcon={<PlusIcon />}
                                                            style={{
                                                                height: '35px',
                                                                color: '#0065FF',
                                                                borderColor: '#0065FF',
                                                                textTransform: 'none',
                                                                borderRadius: '8px',
                                                                minWidth: '110px',
                                                                display: 'flex',
                                                                marginLeft: '10px',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                            }}
                                                        >
                                                            Add
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                tncPointer.map((tncItem, index) => (
                                                <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>

                                                    <Grid item xs={10} sm={10} style={{ paddingRight: 0 }}>
                                                        <div style={{display:'flex',}}>

                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A',marginRight: '5px',marginTop:'1%' }}>{`${index+1})`}</Typography>
                                                        <TextField 
                                                            placeholder={`Please Enter Pointer ${index+1}`} 
                                                            type="text" 
                                                            variant="outlined" 
                                                            fullWidth
                                                            value={tncItem}
                                                            onChange={(e) => handleTncPointerChange(index, e.target.value)}
                                                            error={!!pointerError && index === tncPointer.length - 1}
                                                            helperText={index === tncPointer.length - 1 ? pointerError : ''}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '35px',backgroundColor: '#FFFFFF',borderRadius: '8px 8px 8px 8px',borderRight: 'none'},
                                                            }}
                                                        />
                                                        </div>
                                                    </Grid>

                                                    <Grid item xs={2} sm={2}>
                                                        {index === tncPointer.length - 1 ? (
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={handleAddTncPointer}
                                                                startIcon={<PlusIcon />}
                                                                // disabled={!tncPointer[tncPointer.length - 1]?.trim()}
                                                                style={{
                                                                    height: '35px',
                                                                    color: '#0065FF',
                                                                    borderColor: '#0065FF',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '110px',
                                                                    display: 'flex',
                                                                    marginLeft: '10px',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Add
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() => handleRemoveTncPointer(index)}
                                                                startIcon={<CloseIcon />}
                                                                style={{
                                                                    height: '35px',
                                                                    color: '#D14545',
                                                                    borderColor: '#D14545',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '95px',
                                                                    display: 'flex',
                                                                    marginLeft: '10px',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Remove
                                                            </Button>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            )))}
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Pass Terms & Conditions Link</Label>
                                        <TextField
                                            sx={{marginTop:'1%'}}
                                            value={passTermsLink}
                                            fullWidth
                                            onChange={(e) => setPassTermsLink(e.target.value)}
                                            onBlur={() => {
                                                if (isValidUrl(passTermsLink)) {
                                                    setIsEditingLink(false);
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter' && isValidUrl(passTermsLink)) {
                                                    setIsEditingLink(false);
                                                }
                                            }}
                                            error={passTermsLink && !isValidUrl(passTermsLink)}
                                            helperText={passTermsLink && !isValidUrl(passTermsLink) ? 'Please enter a valid URL' : ''}
                                            InputProps={{
                                                style: { 
                                                    height: '50px', 
                                                    borderRadius: '8px', 
                                                    backgroundColor: '#FFFFFF',
                                                    color: (isValidUrl(passTermsLink) && !isEditingLink) ? '#1976d2' : 'inherit',
                                                    textDecoration: 'none',
                                                    cursor: (isValidUrl(passTermsLink) && !isEditingLink) ? 'pointer' : 'text',
                                                    paddingRight: '40px',
                                                },
                                                readOnly: !isEditingLink && isValidUrl(passTermsLink),
                                                onClick: (isValidUrl(passTermsLink) && !isEditingLink) ? () => {
                                                    window.open(
                                                        passTermsLink.startsWith('http') ? passTermsLink : `https://${passTermsLink}`,
                                                        '_blank',
                                                        'noopener,noreferrer'
                                                    );
                                                } : undefined,
                                                endAdornment: (isValidUrl(passTermsLink) && !isEditingLink) && (
                                                    <IconButton 
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleEditClick();
                                                        }}
                                                        size="small"
                                                        sx={{
                                                            position: 'absolute',
                                                            right: '8px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                                            }
                                                        }}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} style={{marginTop:'1%'}}>
                                        <Label>Pass Terms & Conditions Pointers</Label>
                                        
                                        <div>
                                            {/* <Grid container spacing={2}>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Pointers</Typography>
                                                </Grid>
                                            </Grid> */}

                                            {passTncPointer.length === 0 ? (
                                                // Show at least one empty field if array is empty
                                                <Grid container spacing={0} key={0} style={{ marginTop: '10px' }}>
                                                    <Grid item xs={10} sm={10} style={{ paddingRight: 0 }}>
                                                        <div style={{display:'flex',}}>
                                                            <Typography variant="subtitle2" style={{ color: '#4A4A4A',marginRight: '5px',marginTop:'1%' }}>1)</Typography>
                                                            <TextField 
                                                                placeholder="Please Enter Pointer 1" 
                                                                type="text" 
                                                                variant="outlined" 
                                                                fullWidth
                                                                value=""
                                                                onChange={(e) => handlePassTncPointerChange(0, e.target.value)}
                                                                error={!!passPointerError}
                                                                helperText={passPointerError}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {height: '35px',backgroundColor: '#FFFFFF',borderRadius: '8px 8px 8px 8px',borderRight: 'none'},
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2}>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={handleAddPassTncPointer}
                                                            startIcon={<PlusIcon />}
                                                            style={{
                                                                height: '35px',
                                                                color: '#0065FF',
                                                                borderColor: '#0065FF',
                                                                textTransform: 'none',
                                                                borderRadius: '8px',
                                                                minWidth: '110px',
                                                                display: 'flex',
                                                                marginLeft: '10px',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                            }}
                                                        >
                                                            Add
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                passTncPointer.map((passTncItem, index) => (
                                                <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>

                                                    <Grid item xs={10} sm={10} style={{ paddingRight: 0 }}>
                                                        <div style={{display:'flex',}}>

                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A',marginRight: '5px',marginTop:'1%' }}>{`${index+1})`}</Typography>
                                                        <TextField 
                                                            placeholder={`Please Enter Pointer ${index+1}`} 
                                                            type="text" 
                                                            variant="outlined" 
                                                            fullWidth
                                                            value={passTncItem}
                                                            onChange={(e) => handlePassTncPointerChange(index, e.target.value)}
                                                            error={!!passPointerError && index === passTncPointer.length - 1}
                                                            helperText={index === passTncPointer.length - 1 ? passPointerError : ''}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '35px',backgroundColor: '#FFFFFF',borderRadius: '8px 8px 8px 8px',borderRight: 'none'},
                                                            }}
                                                        />
                                                        </div>
                                                    </Grid>

                                                    <Grid item xs={2} sm={2}>
                                                        {index === passTncPointer.length - 1 ? (
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={handleAddPassTncPointer}
                                                                startIcon={<PlusIcon />}
                                                                // disabled={!tncPointer[tncPointer.length - 1]?.trim()}
                                                                style={{
                                                                    height: '35px',
                                                                    color: '#0065FF',
                                                                    borderColor: '#0065FF',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '110px',
                                                                    display: 'flex',
                                                                    marginLeft: '10px',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Add
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() => handleRemovePassTncPointer(index)}
                                                                startIcon={<CloseIcon />}
                                                                style={{
                                                                    height: '35px',
                                                                    color: '#D14545',
                                                                    borderColor: '#D14545',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '95px',
                                                                    display: 'flex',
                                                                    marginLeft: '10px',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Remove
                                                            </Button>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            )))}
                                        </div>
                                    </Grid>

                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'40px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={openAddModal ? handleSubmit : handleEditSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {openEditModal ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container" sx={{maxHeight:'74vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'trip_id'}
                                    direction={orderBy === 'trip_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('trip_id')}
                                >
                                    Trip ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Route Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Driver Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Phone Number</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Vehicle Number</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Trip Time</TableCell>
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Day</TableCell> */}
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Cancellation Policy Id</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Pass Cancellation Policy Id</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Promotion</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {tripData.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                        tripData.map((row) => {

                            return(
                                <TableRow key={row.id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.trip_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.route_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.driver_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{driverDataShown == 0 ? row.phone_number : (() => {
                                                            if (!row.phone_number) return '****';
                                                            const phone = row.phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.vehicle_number}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.time}</Typography></TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.day}</Typography></TableCell> */}
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.cancellation_policy_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pass_cancellation_policy_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.promo_title ? row.promo_title : "--"}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEdit(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"140px", margin:'2px',
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                            </svg>
                                        </Button>

                                        <Button
                                            variant="contained"
                                            onClick={() => handleViewBookingDetails(row)}
                                            sx={{
                                                backgroundColor: '#F3F8FF', color: '#0065FF', border: '1px solid #0065FF', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"140px", margin:'2px',
                                                '&:hover': {backgroundColor: '#0065FF', color: '#ffffff'},
                                                '&:active': { backgroundColor: '#0065FF', color: '#ffffff'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>View Booking</Typography>
                                            
                                        </Button>

                                        <Button
                                            variant="contained"
                                            onClick={() => handleDeleteTrip(row)}
                                            sx={{
                                                backgroundColor: '#FFF5F5', color: '#0DBA78', border: '1px solid #D14545', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"140px", margin:'2px', color: '#D14545',
                                                '&:hover': {backgroundColor: '#D14545', color: 'white'},
                                                '&:active': { backgroundColor: '#D14545', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Delete</Typography>
                                            
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default ShuttleJourney;